// Typelizer digest 750447494f7b111bad0661f595e4867c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /accountant/clients/:client_id/start */
  update: (
    params: { clientId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/accountant/clients/:client_id/start', params, options),
    method: 'patch',
  }),
}
